<template>
  <div class="brainsSelector-container">
    <input :id="'brainsSelector' + _uid" v-model="inputModel" :list="'brainsSelector-list' + _uid" placeholder="Choose" :class="{'brainsSelector-selected':!!inputModel && inputModel !== ''}" @focus="focusDataResize()" @change="changeDataResize()" @blur="blurDataResize()">
    <datalist :id="'brainsSelector-list' + _uid">
      <option v-for="(item, index) in datalist" :key="index">
        {{ item }}
      </option>
    </datalist>
  </div>
</template>

<script>
export default {
  props: {
    datalist: {
      type: Array,
      required: true
    },
    selectedProperty: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputModel: null,
      selectedModel: null
    }
  },
  mounted() {
    this.selectedModel = this.selectedProperty
    this.inputModel = this.selectedProperty
  },
  methods: {
    focusDataResize() {
      this.inputModel = ''
    },
    changeDataResize() {
      var vm = this
      if (vm.datalist.some(s => s.name === vm.inputModel)) {
        vm.selectedModel = vm.inputModel
        document.getElementById('brainsSelector' + vm._uid).blur()
        vm.$emit('input', vm.selectedModel)
      }
    },
    blurDataResize() {
      // var vm = this
      // if((vm.inputModel === '' || !vm.datalist.some(s => s.name === vm.inputModel)) && !!vm.selectedModel) {
      //   vm.inputModel = vm.selectedModel
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.brainsSelector-container {
  height: 32px;

  input {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    border: 1px solid lightgrey;
    font-family: 'Montserrat-Regular',sans-serif;
    font-size: 12px;
    outline: none;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.8);

    &:focus {
      outline: 1px solid #1e3cff;
    }

    &::-webkit-calendar-picker-indicator {
      opacity: 100;
      cursor: pointer;
      color: lightgrey;
    }
  }
}
</style>
